
<nav class="container">
	<ul class="arrows"
	*rxLet="navigation$; let nav"
	>
	<li
	  class="arrow prev"
	>
	  <a
	    class="route-link"
	    [routerLink]="nav.prev.url"
	    title="{{ nav.prev.title }}"
	  >
	    <div class="button-container">
	      <span class="mat-ripple-container" matRipple></span>
	      <lib-icon class="arrow-icon" name="up" [shadow]="true"></lib-icon>
	    </div>
	  </a>
	</li>
	<li
	  class="arrow next"
	>
	  <a
	    class="route-link"
	    [routerLink]="nav.next.url"
	    title="{{ nav.next.title }}"
	  >
	    <div class="button-container">
	      <span class="mat-ripple-container" matRipple></span>
	      <lib-icon class="arrow-icon" name="up" [shadow]="true"></lib-icon>
	    </div>
	  </a>
	</li>
	</ul>
</nav>